export const SB_ROOT_ELEMENT_SELECTOR = '#root,#storybook-root';
